<script setup>
import AffiliationForm from '@frontJs/components/forms/projectManagement/apikom/AffiliationForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { affiliation } = defineProps({
    affiliation: {
        type: Object,
        required: false,
        default: null,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="affiliation">
            Mettre à jour l'affiliation #{{ affiliation.id }} - Affiliations -
            Apikom - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer une affiliation - Affiliations - Apikom - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="affiliation">
        Gestion de projet - Apikom - Affiliations - Mettre à jour l'affiliation
        #{{ affiliation.id }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Apikom - Affiliations - Créer une affiliation
    </PageTitle>

    <AffiliationForm :affiliation="affiliation" />
</template>
